import { isGuestUrlPermissionLevel } from './isGuestUrlPermissionLevel';
export function getNoPermissionToShareSharingData(sharingData) {
    return sharingData.filter(function (x) { return isUnsharable(x); });
}
function isUnsharable(sharingData) {
    return (sharingData.sharingInfo &&
        sharingData.sharingInfo.getSharingInfoSucceeded &&
        !sharingData.sharingInfo.canShareInternally &&
        !isGuestUrlPermissionLevel(sharingData.currentPermissionLevel) // Guest urls can be shared even if the user doesn't have permission to give access
    );
}
//# sourceMappingURL=getNoPermissionToShareSharingData.js.map